import _Abstract from "system/abstract"



export default class Module_Confirm extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {}, options), 'module')
    this.initModule();
  }

  initModule()
  {
        this.initListeners();
  }

  initListeners()
  {
      var bForcedEvent = false;
      var $clickedElement = null;

      var instanceContext = this;
      
      //--Cancel Button Clicked


        function onCancelPopup()
        {
          $(".m-confirm").hide();
          $(".m-confirm .cancel-btn, .m-confirm .m-confirm__underlay").off("click",onCancelPopup);
          $(".m-confirm .accept-btn").off("click",onAcceptPopup);
        }


        function onAcceptPopup()
        {
          $(".m-confirm").hide();
          bForcedEvent = true;
          $clickedElement.click();
        }


      //--Element bound with alert Clicked
      this.$el.click(function(e)
      {
          if(typeof instanceContext.options.ignore !== "undefined")
          {
              switch( instanceContext.options.ignore.toLowerCase())
              {
                  case "1":
                  case "true":
                  {
                    //Ignoring this if ignore setting is set to 1
                    //Use an ignore setting, as its easier to switch one value to 1 and 0 then to take away all of the components
                    return;
                    break;
                  }
              }
          }

          if(bForcedEvent)
          {
            bForcedEvent = false;
            return;
          }

          $(".m-confirm__text").html(instanceContext.options.text);


        if(typeof e !== "undefined" && e)
        {
            $clickedElement = e.originalEvent.target;
            e.preventDefault();
        }

        $(".m-confirm").show();
        $(".m-confirm .cancel-btn, .m-confirm .m-confirm__underlay").on("click",onCancelPopup);
        $(".m-confirm .accept-btn").on("click",onAcceptPopup);
      });

  }
}



/** WEBPACK FOOTER **
 ** ./modules/confirm.js
 **/